module.exports = __webpack_public_path__ + "img/FCT.f79ac374.svg";